import AutoplayModel from "slotworks/model/autoplay-model";
import SmartButton from "slotworks/smart-button/smart-button";
import { SmartButtonFlag } from "slotworks/smart-button/smart-button";

export function StopAutoplayCommand() {
    AutoplayModel.stop();
    SmartButton.setFlag(SmartButtonFlag.AUTO_SPIN, false);
    SmartButton.refresh();
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/autoplay/stop-autoplay.ts